import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=548eecb9&"
import script from "./ProductAttributes.vue?vue&type=script&lang=js&"
export * from "./ProductAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports